<template>
  <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6 sm:items-center">
    <dt class="text-sm font-medium text-gray-500">Account</dt>
    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-3 space-y-1">
      <div v-if="relatedAccount">
        {{ relatedAccount.name }}
      </div>
      <div v-else-if="accountRelation">
        {{ accountRelation.name }}
      </div>
      <div v-else>-</div>
    </dd>
  </div>
</template>

<script>
export default {
  props: {
    accountRelationId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    accountRelation() {
      return this.$store.state.entities.accountRelations.byId[this.accountRelationId];
    },
    relatedAccount() {
      if (!this.accountRelation) {
        return null;
      }

      return this.$store.state.entities.accounts.byId[this.accountRelation.related_account_uuid];
    },
  },
  created() {
    if (!this.accountRelation || !this.relatedAccount || !this.relatedAccount.registrations) {
      this.fetchAccountRelation();
    }
  },
  methods: {
    setLoading(value) {
      this.loading = Boolean(value);
    },
    async fetchAccountRelation() {
      try {
        this.setLoading(true);
        await this.$store.dispatch({
          type: 'ui/accountRelations/read',
          accountRelationId: this.accountRelationId,
          queryParams: {
            include: 'relatedAccount.logo,relatedAccount.registrations',
          },
        });
      } catch (error) {
        //
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>
